module.exports = __webpack_public_path__ + "static/media/icon-drop-up.056dde4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/help/section-content/img/icon-drop-up.svg
// module id = 1131
// module chunks = 2